import './offer.css';

import { domain, main_domain, ogImage } from 'config';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Content from '../../components/card';

import { getOffer, getOfferIdle } from '../../store/ducks/offer/actions';
import { selectorCards } from '../../store/ducks/offer/selector';
import Card from 'components/card/card';
import { useParams } from 'react-router-dom';

import Node from '../../components/card/component/node';
import ServiceCard from 'components/service_card';
import StoryCard from 'components/story_card';

import Masonry from 'react-masonry-component';
import { Helmet } from 'react-helmet';

type Props = {};

const Offer = (props: Props) => {
    const { slug }: any = useParams();

    const dispatch = useDispatch();

    const { status, data }: any = useSelector(
        (state: { offer: any }) => state.offer
    );
    const collectionsPosts = useSelector(
        (state: any) => state.homepage.collectionsPosts
    );

    const cards = useSelector(selectorCards);
    const posts = useSelector((state: any) => state.offer.posts);

    useEffect(() => {
        if (status == 'IDLE') {
            dispatch(
                getOffer({
                    slug: slug,
                })
            );
        }
    }, [slug]);

    useEffect(() => {
        if (status == 'SUCCESS') {
            dispatch(getOfferIdle());
        }
    }, [status]);

    // useEffect(() => {
    //     if(status == 'IDLE'){
    //         dispatch(getPost({
    //             slug: slug
    //         }));
    //     }
    // }, [])

    const handleScrollAnchor = (e: any, index: any) => {
        e.preventDefault();

        window.scrollTo({
            top:
                document
                    .querySelectorAll('.page__content .card')
                    [index].getBoundingClientRect().top + window.scrollY,
            behavior: 'smooth',
        });
    };

    return (
        <>
            <Helmet>
                <meta
                    property="og:url"
                    content={main_domain + '/offers/' + slug}
                />
                <meta property="og:type" content="page" />
                <title>
                    {(data &&
                        data.attributes &&
                        ((data.attributes.OG_Title &&
                            data.attributes.OG_Title) ||
                            data.attributes.Title)) ||
                        ''}
                </title>
                <meta
                    name="description"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Description &&
                                data.attributes.OG_Description) ||
                                '')) ||
                        ''
                    }
                ></meta>
                <meta
                    property="og:title"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Title &&
                                data.attributes.OG_Title) ||
                                data.attributes.Title)) ||
                        ''
                    }
                />
                <meta
                    property="og:description"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Description &&
                                data.attributes.OG_Description) ||
                                '')) ||
                        ''
                    }
                />
                <meta
                    property="og:image"
                    content={
                        (data && data.ogurl) ||
                        (data &&
                            data.attributes &&
                            data.attributes.OG_Image &&
                            data.attributes.OG_Image.data &&
                            domain +
                                data.attributes.OG_Image.data.attributes.url) ||
                        ogImage
                    }
                />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta
                    property="vk:image"
                    content={
                        (data && data.ogurl) ||
                        (data &&
                            data.attributes &&
                            data.attributes.OG_Image &&
                            data.attributes.OG_Image.data &&
                            domain +
                                data.attributes.OG_Image.data.attributes.url) ||
                        ogImage
                    }
                />
                <meta property="vk:image:width" content="537" />
                <meta property="vk:image:height" content="240" />
                <meta
                    property="twitter:image"
                    content={
                        (data && data.ogurl) ||
                        (data &&
                            data.attributes &&
                            data.attributes.OG_Image &&
                            data.attributes.OG_Image.data &&
                            domain +
                                data.attributes.OG_Image.data.attributes.url) ||
                        ogImage
                    }
                />
                <meta property="twitter:image:width" content="1024" />
                <meta property="twitter:image:height" content="512" />
                <meta
                    name="twitter:title"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Title &&
                                data.attributes.OG_Title) ||
                                data.attributes.Title)) ||
                        ''
                    }
                />
                <meta
                    name="twitter:description"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Description &&
                                data.attributes.OG_Description) ||
                                '')) ||
                        ''
                    }
                />
                <meta name="twitter:card" content="summary_large_image" />
                <link rel="canonical" href={main_domain + '/offers/' + slug} />
            </Helmet>
            <div className={`page _post`}>
                <div className="container">
                    {data && data.attributes && (
                        <div className="page__entry">
                            {data.attributes.IsPartner && (
                                <div className="page__is-partner">
                                    <span className="tag _yellow">
                                        Партнерский пост
                                    </span>
                                </div>
                            )}
                            <div className="page__category-title">
                                <h2>
                                    {data.attributes.Post_category &&
                                        data.attributes.Post_category.data &&
                                        data.attributes.Post_category.data
                                            .attributes.Title}
                                </h2>
                            </div>
                            {data && data.attributes && data.attributes.Title && (
                                <div className="page__title">
                                    <h1 className="_h2">
                                        {(data.attributes.TitleInner &&
                                            data.attributes.TitleInner) ||
                                            data.attributes.Title}
                                    </h1>
                                </div>
                            )}
                            {((data.attributes.Preview &&
                                data.attributes.Preview.data) ||
                                (data.attributes.Emoji &&
                                    data.attributes.Emoji.data) ||
                                data.attributes.Lead) && (
                                <div className="page__common">
                                    <div className="page__preview">
                                        {data &&
                                            data.attributes &&
                                            ((data.attributes.Preview &&
                                                data.attributes.Preview.data) ||
                                                (data.attributes.Emoji &&
                                                    data.attributes.Emoji
                                                        .data)) && (
                                                <>
                                                    {data.attributes.Emoji &&
                                                        data.attributes.Emoji
                                                            .data && (
                                                            <div className="page__preview-emoji">
                                                                <img
                                                                    src={
                                                                        domain +
                                                                        data
                                                                            .attributes
                                                                            .Emoji
                                                                            .data
                                                                            .attributes
                                                                            .url
                                                                    }
                                                                />
                                                            </div>
                                                        )}
                                                    {data.attributes.Preview &&
                                                        data.attributes.Preview
                                                            .data &&
                                                        data.attributes.Preview
                                                            .data.length ==
                                                            1 && (
                                                            <div
                                                                className={`page__preview-image ${
                                                                    (data
                                                                        .attributes
                                                                        .IsMaskPreview &&
                                                                        '_rounded') ||
                                                                    ''
                                                                }`}
                                                            >
                                                                <img
                                                                    src={
                                                                        domain +
                                                                        data
                                                                            .attributes
                                                                            .Preview
                                                                            .data[0]
                                                                            .attributes
                                                                            .url
                                                                    }
                                                                />
                                                            </div>
                                                        )}
                                                    {data.attributes.Preview &&
                                                        data.attributes.Preview
                                                            .data &&
                                                        data.attributes.Preview
                                                            .data.length >
                                                            1 && (
                                                            <div className="page__preview-list">
                                                                {data.attributes.Preview.data.map(
                                                                    (
                                                                        image: any,
                                                                        index: any
                                                                    ) => {
                                                                        return (
                                                                            <div
                                                                                className="page__preview-list-item"
                                                                                key={
                                                                                    index
                                                                                }
                                                                            >
                                                                                <img
                                                                                    src={
                                                                                        domain +
                                                                                        image
                                                                                            .attributes
                                                                                            .url
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        )}
                                                </>
                                            )}
                                    </div>
                                    <div className="page__lead">
                                        {data.attributes.Lead &&
                                            data.attributes.Lead.map(
                                                (node: any, index: any) => {
                                                    return (
                                                        <Node
                                                            key={index}
                                                            {...node}
                                                        />
                                                    );
                                                }
                                            )}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    <div className="page__wrap">
                        <div className="page__sidebar"></div>

                        <div className="page__content">
                            {cards.map((components: any, index: any) => {
                                return (
                                    <Card key={index} components={components} />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="section _posts">
                <div className="container _wide">
                    <div className="section__title">
                        <div className="_h1">
                            Что происходит в&nbsp;нормальном Дубае
                        </div>
                    </div>
                    <div className="section__grid">
                        <Masonry>
                            {posts.map((post: any, index: any) => {
                                return (
                                    <div
                                        className="section__grid-item"
                                        key={index}
                                    >
                                        <StoryCard
                                            link={
                                                '/posts/' + post.attributes.Slug
                                            }
                                            IsMaskPreview={
                                                (post.attributes
                                                    .IsMaskPreview &&
                                                    post.attributes
                                                        .IsMaskPreview) ||
                                                false
                                            }
                                            emoji={
                                                (post.attributes.Emoji.data &&
                                                    domain +
                                                        post.attributes.Emoji
                                                            .data.attributes
                                                            .url) ||
                                                null
                                            }
                                            image={
                                                (post.attributes.Preview.data &&
                                                    post.attributes.Preview.data
                                                        .length == 1 &&
                                                    domain +
                                                        post.attributes.Preview
                                                            .data[0].attributes
                                                            .url) ||
                                                null
                                            }
                                            images={
                                                (post.attributes.Preview.data &&
                                                    post.attributes.Preview.data
                                                        .length > 1 &&
                                                    post.attributes.Preview
                                                        .data) ||
                                                null
                                            }
                                            title={post.attributes.Title}
                                            description={
                                                post.attributes.Description
                                            }
                                            className={
                                                (post.attributes.Post_category
                                                    .data &&
                                                    post.attributes
                                                        .Post_category.data
                                                        .id == 4 &&
                                                    '_guide') ||
                                                ''
                                            }
                                            background={
                                                post.attributes.Background
                                            }
                                        />
                                    </div>
                                );
                            })}
                        </Masonry>
                    </div>
                    {/* {postsMeta &&
                        postsMeta.pagination.total !== posts.length && (
                            <div className="section__loadmore">
                                <Button
                                    className={'_default _dark _large'}
                                    attributes={{
                                        onClick: () => {
                                            if (statusPosts == 'IDLE') {
                                                let filters =
                                                    '&pagination[start]=' +
                                                    ( posts.length - 1 ) +
                                                    '&pagination[limit]=8';
                                                if (activeCategory !== '') {
                                                    filters =
                                                        filters +
                                                        '&filters[Post_category][id][$in]=' +
                                                        activeCategory;
                                                }
                                                dispatch(
                                                    getPosts({
                                                        filter: filters,
                                                    })
                                                );
                                            }
                                        },
                                    }}
                                >
                                    Читать еще
                                </Button>
                            </div>
                        )} */}
                </div>
            </div>
            {/* {data &&
                data.attributes &&
                collectionsPosts.map((collection: any) => {
                    return (
                        <div className="section _selection">
                            <div className="container _wide">
                                <div className="section__title">
                                    <div className="_h1">
                                        {collection.attributes.Title}
                                    </div>
                                </div>

                                <div className="section__grid">
                                    <Masonry>
                                        {collection.attributes.Posts.data.map(
                                            (post: any, index: any) => {
                                                return (
                                                    <div
                                                        className="section__grid-item"
                                                        key={index}
                                                    >
                                                        <StoryCard
                                                            link={
                                                                '/posts/' +
                                                                post.attributes
                                                                    .Slug
                                                            }
                                                            emoji={
                                                                (post.attributes
                                                                    .Emoji
                                                                    .data &&
                                                                    domain +
                                                                        post
                                                                            .attributes
                                                                            .Emoji
                                                                            .data
                                                                            .attributes
                                                                            .url) ||
                                                                null
                                                            }
                                                            image={
                                                                (post.attributes
                                                                    .Preview
                                                                    .data &&
                                                                    post
                                                                        .attributes
                                                                        .Preview
                                                                        .data
                                                                        .length ==
                                                                        1 &&
                                                                    domain +
                                                                        post
                                                                            .attributes
                                                                            .Preview
                                                                            .data[0]
                                                                            .attributes
                                                                            .url) ||
                                                                null
                                                            }
                                                            images={
                                                                (post.attributes
                                                                    .Preview
                                                                    .data &&
                                                                    post
                                                                        .attributes
                                                                        .Preview
                                                                        .data
                                                                        .length >
                                                                        1 &&
                                                                    post
                                                                        .attributes
                                                                        .Preview
                                                                        .data) ||
                                                                null
                                                            }
                                                            title={
                                                                post.attributes
                                                                    .Title
                                                            }
                                                            description={
                                                                post.attributes
                                                                    .Description
                                                            }
                                                            background={
                                                                post.attributes
                                                                    .Background
                                                            }
                                                        />
                                                    </div>
                                                );
                                            }
                                        )}
                                    </Masonry>
                                </div>
                            </div>
                        </div>
                    );
                })} */}
        </>
    );
};

export default Offer;
